import { initItemPage } from 'src/lib/item-page.js'
import Vue from 'vue'
import DatasetDistributionsDisplay from 'src/components/dataset/pages/DatasetDistributionsDisplay.vue'
import BoundingBoxRepresentation from 'src/components/geospatial/BoundingBoxRepresentation.vue'

initItemPage()

function withVueComponent(components) {
    return function(element) {
        new Vue({
            el: element,
            components: components
        })
    }
}

const widgets = {
    "vue-dataset-distributions-widget-container": withVueComponent({'dataset-distributions-display': DatasetDistributionsDisplay}),
    "vue-geospatial-map-widget-container": withVueComponent({'bounding-box-representation': BoundingBoxRepresentation})
}

document.addEventListener('DOMContentLoaded', function() {
    for (const [hostElementID, f] of Object.entries(widgets)) {
        const hostElement = document.querySelector(`#${hostElementID}`);
        if (hostElement !== undefined ) {
            f(hostElement);
        }
    }
}, false);
